const gbpFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
});

const plainFormatter = new Intl.NumberFormat('en-GB', {
  useGrouping: false,
  maximumFractionDigits: 20,
});

/** GBP amounts without thousand separators (e.g. £1234.56 not £1,234.56). */
export function formatCurrencyGBP(amount: number | string | null | undefined): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : Number(amount ?? 0);
  if (Number.isNaN(num)) return gbpFormatter.format(0);
  return gbpFormatter.format(num);
}

/** Numeric display without grouping (integers and decimals). */
export function formatNumberPlain(value: number): string {
  return plainFormatter.format(value);
}
